import { is } from 'stdlib/is'

import type Text from '../Text'

/** Nyelvváltáskor megfutó callback. */
export default function onTranslateChanged (): void {
  const texts: Text[] = Array.from(document.querySelectorAll('sen-text'))

  texts.forEach((text) => {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (is.function(text.refresh)) {
      text.refresh()
    }
  })
}
